// Port of api/fuel/app/classes/controller/api/monty/session/groupsyncs.php
import Constants from 'offline/constants'
import DB from 'offline/db'
import User from 'offline/model/user'

function userId(params) {
	return params.sessionUserId || DB.meta('sync_user_id') || false
}

function syncsToJson(row) {
	var user = User.with_id(row.user_id)

	return {
		id: parseInt(row.syncs_id, 10),
		value: row.syncs_value,
		ready: parseInt(row.syncs_status, 10),
		date: parseInt(row.syncs_date, 10),
		user: user ? user.get_name() : '',
		recipient: parseInt(row.syncs_recipient, 10),
		canCancel: !parseInt(row.syncs_status, 10),
		canRemove: !!parseInt(row.syncs_status, 10) && (Math.floor(Date.now() / 1000) >= parseInt(row.syncs_date, 10) + Constants.TIME_WEEK),
		removeDate: parseInt(row.syncs_date, 10) + Constants.TIME_WEEK
	}
}

export default function(params) {
	var method = params.__offlineMethod || 'GET'
	var uid = userId(params)

	if (!uid) {
		return Promise.reject({ error: 'Not available offline without a local session.', offline: true })
	}

	if (method !== 'GET') {
		return Promise.reject({ error: 'This action is not available offline.', offline: true })
	}

	var rows = DB.query(
		'SELECT * FROM platform_syncs WHERE user_id = ? AND syncs_type = ? ORDER BY syncs_date DESC LIMIT 1',
		[uid, Constants.TYPE_GROUP]
	)

	return Promise.resolve({
		session: { offline: true },
		data: {
			group: rows.length ? syncsToJson(rows[0]) : false
		}
	})
}
